export default "__VITE_ASSET__31PVJbCy__"